@use '@/scss/underscore' as _;

.tooltip {
  position: absolute;

  .content {
    @include _.multi-line-ellipsis(6);
  }
}
